import {
    CONFIRM_BOOKING,
    CONFIRM_BOOKING_SUCCESS,
    CONFIRM_BOOKING_FAILED,
    CLEAR_BOOKING
} from "../store/types";
import { backend } from '../config/configureBackend';
import { formatBookingObject } from '../other/sharedFunctions';
import { get } from "../config/supabaseDatabaseCompat";
import { supabase } from '../config/supabaseClient';
import { apiUrl } from '../config/apiConfig';

export const clearBooking = () => (dispatch) => {
    dispatch({
        type: CLEAR_BOOKING,
        payload: null,
    });
}

export const addBooking = (bookingData) => async (dispatch) => {

    const   {
        settingsRef,
    } = backend;

    dispatch({
        type: CONFIRM_BOOKING,
        payload: bookingData,
    });

    const settingsdata = await get(settingsRef);
    const settings = settingsdata.val();

    let data = await formatBookingObject(bookingData, settings);

    try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.access_token) throw new Error('Sign in again before creating a booking.');
        const response = await fetch(apiUrl('bookings/create'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${session.access_token}`,
            },
            body: JSON.stringify({ booking: data }),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error || 'Unable to create booking.');
        dispatch({
            type: CONFIRM_BOOKING_SUCCESS,
            payload: {
                booking_id: result.booking_id,
                mainData: result.mainData
            }    
        });
    } catch (error) {
        dispatch({
            type: CONFIRM_BOOKING_FAILED,
            payload: error.message || error,
        });
    }
};
